"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReportTemplateOutput = instanceOfReportTemplateOutput;
exports.ReportTemplateOutputFromJSON = ReportTemplateOutputFromJSON;
exports.ReportTemplateOutputFromJSONTyped = ReportTemplateOutputFromJSONTyped;
exports.ReportTemplateOutputToJSON = ReportTemplateOutputToJSON;
var ReportTemplate_1 = require("./ReportTemplate");
var Metadata_1 = require("./Metadata");
/**
 * Check if a given object implements the ReportTemplateOutput interface.
 */
function instanceOfReportTemplateOutput(value) {
    if (!('data' in value) || value['data'] === undefined)
        return false;
    return true;
}
function ReportTemplateOutputFromJSON(json) {
    return ReportTemplateOutputFromJSONTyped(json, false);
}
function ReportTemplateOutputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'data': (json['data'].map(ReportTemplate_1.ReportTemplateFromJSON)),
        'metadata': json['metadata'] == null ? undefined : (0, Metadata_1.MetadataFromJSON)(json['metadata']),
    };
}
function ReportTemplateOutputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'data': (value['data'].map(ReportTemplate_1.ReportTemplateToJSON)),
        'metadata': (0, Metadata_1.MetadataToJSON)(value['metadata']),
    };
}
